import React from "react";
import styles from "./buttons.scss";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const props = {
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
  styl: PropTypes.object,
  type: PropTypes.string,
  btn: PropTypes.bool
};

const Button = props => {
  const opts = {};
  if (props.download) {
    opts["download"] = true;
  }
  if (props.disabled) {
    opts["disabled"] = true;
  }
  if (props.external) {
    opts["target"] = "_blank";
    opts["rel"] = "noreferrer noopener"
  }
  return props.btn ? (
    <button {...opts} type={props.type || "submit"} className={props.cls} style={props.style} onClick={props.onClick}>
      {props.text}
    </button>
  ) : props.external || props.download || PRODUCTION ? (
    <a className={props.cls} href={props.link} {...opts} style={props.style}>
      {props.text}
    </a>
  ) : (
    <Link to={{ pathname: props.link }} className={props.cls} style={props.style}>
      {props.text}
    </Link>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
  cls: PropTypes.string.isRequired,
  btn: PropTypes.bool
};

export const Primary = props => {
  return <Button {...props} cls={`${props.cls || ""} ${styles.primary}`} />;
};
Primary.propTypes = props;
export const PrimaryOutline = props => {
  return <Button {...props} cls={`${props.cls || ""} ${styles.primaryOutline}`} />;
};
PrimaryOutline.propTypes = props;

export const Secondary = props => {
  return <Button {...props} cls={`${props.cls || ""} ${styles.secondary}`} />;
};
Secondary.propTypes = props;
export const SecondaryOutline = props => {
  return <Button {...props} cls={`${props.cls || ""} ${styles.secondaryOutline}`} />;
};
SecondaryOutline.propTypes = props;

export const White = props => {
  return <Button {...props} cls={`${props.cls || ""} ${styles.white}`} />;
};
White.propTypes = props;

export const WhiteOutline = props => {
  return <Button {...props} cls={`${props.cls || ""} ${styles.whiteOutline}`} />;
};
WhiteOutline.propTypes = props;
